// extracted by mini-css-extract-plugin
export var backdropBlur = "_kn-0";
export var contentCard = "_kn-5";
export var frame = "_kn-2";
export var image = "_kn-4";
export var imagePane = "_kn-3";
export var modal = "_kn-1";